/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.task.assignment.rpc.TaskAssignmentRpc
 */

export const assignOnboardingTaskRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.TaskAssignmentRpc',
  rpcName: 'assignOnboardingTask',
  auth: 'app',
  fingerprint: 'j_4GE3CqscZlHT2Xx9Y_QZN3v2LSV3RK'
};
export const getAllRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.TaskAssignmentRpc',
  rpcName: 'getAll',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADE2-C6mCQ3vJN3v2LSV3RK'
};
export const getTaskAssignmentByUserIdRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.TaskAssignmentRpc',
  rpcName: 'getTaskAssignmentByUserId',
  auth: 'app',
  fingerprint: 'bowCwDEbGdg7Ln07KCInvpN3v2LSV3RK'
};
export const getTaskAssignmentByTaskIdRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.TaskAssignmentRpc',
  rpcName: 'getTaskAssignmentByTaskId',
  auth: 'app',
  fingerprint: '8dcMIpJuNJ8llzDgSlfWipN3v2LSV3RK'
};
export const deleteTaskAssignmentByIdRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.TaskAssignmentRpc',
  rpcName: 'deleteTaskAssignmentById',
  auth: 'app',
  fingerprint: 'Xse9EljXr7UIu1Lu0WGwpJN3v2LSV3RK'
};